
import {Component, Vue} from 'vue-property-decorator';
//@ts-ignore
import CookieLaw from 'vue-cookie-law'

@Component({components: {CookieLaw}})
export default class PageFooter extends Vue {

  thisYear = this.$moment().format("Y")

  get appVersion() {
    return this.$version.app
  }
}
